import type { UserProfileCompleteDto, ApiResponse } from '@/types/user'
import { apiClient } from './client'

export const userApi = {
  // Me endpoint - returns complete user profile with roles and workspaces
  async getMe(): Promise<ApiResponse<UserProfileCompleteDto>> {
    const endpoint = `/api/Users/Me`
    return apiClient.get<UserProfileCompleteDto>(endpoint)
  }
}
